import { render, staticRenderFns } from "./MainCRM.vue?vue&type=template&id=46b882aa&"
import script from "./MainCRM.vue?vue&type=script&lang=js&"
export * from "./MainCRM.vue?vue&type=script&lang=js&"
import style0 from "./MainCRM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports